import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import QCReportModal from '../components/modals/QCReportModal';
const Range = Slider.Range;

const Reports = (props) => {
	const [reportFilters, setReportFilters] = useState({
		id: '',
		user: '',
		sDate: '',
		eDate: '',
		qcType: '',
		commodity: '',
		numCaps: '',
		postQCCompl: '',
		uploadCompl: ''
	});

	const [filteredReports, setFilteredReports] = useState([]);
	const [range, setRange] = React.useState([20, 80]);
	const [selectedReport, setSelectedReport] = useState(null);

	const qcTypeList = ['Daily', 'Historic', 'Re-QC', 'Upload Only'];

	// example of what reports EP might return
	let qcReportJSON = [
		{
			id: 1001,
			user: 'user1',
			commodity: 'steel',
			qcType: 'Daily',
			queueID: 7771,
			queueCreatedDate: '11/10/2024',
			queueCreatedTime: '18:11',
			recordID: 228746,
			capsInQueue: [
				85749, 87551, 87357, 88241, 81401, 89738, 83278, 86184, 89377, 83052
			],
			capsAutoQCd: [85749, 87551, 87357, 88241],
			capsQCd: [81401, 89738, 83278],
			capsNotQCd: [86184, 89377, 83052],
			agreeDisagreeRatio: { agree: 2, disagree: 1 },
			postQCStarted: '18:11',
			executionID: 'randomID',
			postQCData: { captures: 39460, sites: 1784 },
			uploadStarted: '18:11',
			uploadedCompeleted: '18:11'
		},
		{
			id: 1501,
			user: 'user2',
			commodity: 'steel',
			qcType: 'Daily',
			queueID: 1572,
			queueCreatedDate: '22/07/2024',
			queueCreatedTime: '19:43',
			recordID: 214326,
			capsInQueue: [
				89368, 88508, 80364, 84266, 82629, 88717, 83594, 82339, 88701, 84218,
				82166, 80236, 81206
			],
			capsAutoQCd: [89368, 88508, 80364, 84266, 82629],
			capsQCd: [88717, 83594, 82339],
			capsNotQCd: [88701, 84218, 82166, 80236, 81206],
			agreeDisagreeRatio: { agree: 1, disagree: 2 },
			postQCStarted: null,
			executionID: null,
			postQCData: null,
			uploadStarted: null,
			uploadedCompeleted: null
		},
		{
			id: 2001,
			user: 'user3',
			commodity: 'steel',
			qcType: 'Historic',
			queueID: 3597,
			queueCreatedDate: '26/06/2024',
			queueCreatedTime: '20:13',
			recordID: 757576,
			capsInQueue: [
				89460, 83679, 81490, 88995, 84378, 88744, 88591, 80109, 83495, 87323,
				84411, 83293, 88077, 86253, 82367, 83494, 81650
			],
			capsAutoQCd: [89460, 83679, 81490, 88995, 84378, 88744],
			capsQCd: [88591, 80109, 83495, 87323, 84411, 83293],
			capsNotQCd: [88077, 86253, 82367, 83494, 81650],
			agreeDisagreeRatio: { agree: 5, disagree: 1 },
			postQCStarted: '20:13',
			executionID: 'randomID',
			postQCData: { captures: 28914, sites: 2786 },
			uploadStarted: '20:13',
			uploadedCompeleted: '20:13'
		},
		{
			id: 2501,
			user: 'user4',
			commodity: 'steel',
			qcType: 'Historic',
			queueID: 5184,
			queueCreatedDate: '08/06/2024',
			queueCreatedTime: '10:36',
			recordID: 370421,
			capsInQueue: [88289, 83638, 88092, 81271, 85966],
			capsAutoQCd: [88289, 83638],
			capsQCd: [88092],
			capsNotQCd: [81271, 85966],
			agreeDisagreeRatio: { agree: 1, disagree: 0 },
			postQCStarted: '10:36',
			executionID: 'randomID',
			postQCData: { captures: 18841, sites: 2820 },
			uploadStarted: null,
			uploadedCompeleted: null
		},
		{
			id: 3001,
			user: 'user5',
			commodity: 'steel',
			qcType: 'Daily',
			queueID: 8893,
			queueCreatedDate: '26/10/2024',
			queueCreatedTime: '13:00',
			recordID: 707750,
			capsInQueue: [
				88714, 87487, 87217, 84108, 84439, 86067, 81235, 89328, 86745, 85889,
				87274, 81829
			],
			capsAutoQCd: [88714, 87487, 87217],
			capsQCd: [84108, 84439, 86067, 81235],
			capsNotQCd: [89328, 86745, 85889, 87274, 81829],
			agreeDisagreeRatio: { agree: 4, disagree: 0 },
			postQCStarted: null,
			executionID: null,
			postQCData: null,
			uploadStarted: null,
			uploadedCompeleted: null
		},
		{
			id: 2100,
			user: 'user1',
			commodity: 'steel',
			qcType: 'Daily',
			queueID: 8894,
			queueCreatedDate: '26/10/2024',
			queueCreatedTime: '13:00',
			recordID: 707750,
			capsInQueue: [
				88714, 87487, 87217, 84108, 84439, 86067, 81235, 89328, 86745, 85889,
				87274, 81829
			],
			capsAutoQCd: [88714, 87487, 87217],
			capsQCd: [84108, 84439, 86067, 81235],
			capsNotQCd: [89328, 86745, 85889, 87274, 81829],
			agreeDisagreeRatio: { agree: 4, disagree: 0 },
			postQCStarted: null,
			executionID: null,
			postQCData: null,
			uploadStarted: null,
			uploadedCompeleted: null
		}
	];

	useEffect(() => {
		handleFilterReports(reportFilters);
	}, [reportFilters]);

	const handleFilterReports = (filter) => {
		let newList = qcReportJSON;

		if (filter.id) {
			newList = newList.filter((report) =>
				report.id.toString().includes(filter.id)
			);
		}

		if (filter.user) {
			newList = newList.filter((report) =>
				report.user.toString().includes(filter.user)
			);
		}

		if (filter.qcType !== '') {
			newList = newList.filter((report) => report.qcType === filter.qcType);
		}

		//
		if (filter.sDate && !filter.eDate) {
			console.log(filter.sDate);
			console.log(filter.eDate);

			newList = qcReportJSON.filter(
				(report) => new Date(report.queueCreatedDate) > new Date(filter.sDate)
			);
		}

		// if (!filter.sDate && filter.eDate) {
		// 	newList = qcReportJSON.filter((report) =>
		// 	new Date(report.queueCreatedDate) < new Date(filter.eDate)
		// 	);
		// }

		// if (filter.sDate && filter.eDate) {
		// 	newList = qcReportJSON.filter((report) =>
		// 	report.queueCreatedDate < filter.eDate && report.queueCreatedDate > filter.sDate
		// 	);
		// }
		//

		setFilteredReports(newList);
	};

	console.log(selectedReport);

	return (
		<>
			{props.authProps.isAuthenticated ? (
				<>
					{selectedReport && (
						<QCReportModal
							selectedReport={selectedReport}
							onClose={() => setSelectedReport(null)}
						/>
					)}

					<div className="col px-0">
						<div className="contentContainer">
							<hr style={{ marginTop: '58px' }}></hr>
							<h2>Reports</h2>
							<h5>Use this page to view a historic log of previous QC</h5>

							<div className="table table-responsive mt-4">
								<table className="captureTable">
									<thead className="thead-dark">
										<tr>
											<th>ID</th>
											<th>User</th>
											<th>Date </th>
											<th>Time</th>
											<th>Commodity</th>
											<th>QC Type</th>
											<th>No. captures</th>
											<th>Post QC completed</th>
											<th>Upload completed</th>
											<th>View Report</th>
										</tr>
										<tr>
											<th>
												<div className="d-flex justify-content-center">
													<input
														type="text"
														className="form-control"
														value={reportFilters.id}
														onChange={(e) =>
															setReportFilters({
																...reportFilters,
																id: e.target.value
															})
														}
													></input>
													<button
														type="button"
														className="btn-close btn-close-white btn-sm pt-3 ms-2 text-light"
														aria-label="Close"
														style={{ fontSize: '12px' }}
														onClick={() =>
															setReportFilters({
																...reportFilters,
																id: ''
															})
														}
													></button>
												</div>
											</th>
											<th>
												<div className="d-flex justify-content-center">
													<input
														type="text"
														className="form-control"
														value={reportFilters.user}
														onChange={(e) =>
															setReportFilters({
																...reportFilters,
																user: e.target.value
															})
														}
													></input>
													<button
														type="button"
														className="btn-close btn-close-white btn-sm pt-3 ms-2 text-light"
														aria-label="Close"
														style={{ fontSize: '12px' }}
														onClick={() =>
															setReportFilters({
																...reportFilters,
																user: ''
															})
														}
													></button>
												</div>
											</th>
											<th colSpan={2}>
												<div className="d-flex justify-content-center">
													<input
														type="date"
														className="form-control"
														value={reportFilters.sDate}
														onChange={(e) =>
															setReportFilters({
																...reportFilters,
																sDate: e.target.value
															})
														}
													></input>
													<input
														type="date"
														className="form-control"
														value={reportFilters.eDate}
														onChange={(e) =>
															setReportFilters({
																...reportFilters,
																eDate: e.target.value
															})
														}
													></input>
													<button
														type="button"
														className="btn-close btn-close-white btn-sm pt-3 ms-2 text-light"
														aria-label="Close"
														style={{ fontSize: '12px' }}
														onClick={() =>
															setReportFilters({
																...reportFilters,
																eDate: '',
																sDate: ''
															})
														}
													></button>{' '}
												</div>
											</th>
											<th>
												<div className="d-flex justify-content-center"></div>
											</th>
											<th>
												<div className="d-flex justify-content-center">
													<select
														className="form-control"
														value={reportFilters.qcType}
														onChange={(e) =>
															setReportFilters({
																...reportFilters,
																qcType: e.target.value
															})
														}
													>
														<option value="">All</option>
														{qcTypeList.map((type) => (
															<option key={type} value={type}>
																{type}
															</option>
														))}
													</select>
												</div>
											</th>
											<th></th>
											<th></th>
											<th></th>
											<th></th>
										</tr>
									</thead>

									<tbody>
										{filteredReports.length > 0 &&
											filteredReports.map((entry, idx) => (
												<>
													<tr key={idx}>
														<td>{entry.id}</td>
														<td>{entry.user}</td>
														<td>{entry.queueCreatedDate}</td>
														<td>{entry.queueCreatedTime}</td>
														<td>{entry.commodity}</td>
														<td>{entry.qcType}</td>
														<td>{entry.capsInQueue.length}</td>
														{entry.postQCStarted ? (
															<td>
																<i className="fa-regular fa-circle-check"></i>
															</td>
														) : (
															<td>-</td>
														)}
														{entry.uploadStarted ? (
															<td>
																<i className="fa-regular fa-circle-check"></i>
															</td>
														) : (
															<td>-</td>
														)}
														<td>
															<i
																className="fa fa-solid fa-file-lines"
																onClick={(e) =>
																	setSelectedReport(entry)
																}
																id="captureImageHover"
																data-tooltip-id={`view-report-tt`}
															></i>
														</td>
													</tr>
												</>
											))}
									</tbody>
								</table>

								<Tooltip id={`view-report-tt`} place="top" effect="solid">
									View report
								</Tooltip>
							</div>
						</div>
					</div>
				</>
			) : (
				<Navigate to="/login" />
			)}
		</>
	);
};

export default Reports;
